import { isNonEmpty } from '@sgme/fp';
import { connect } from 'react-redux';
import { getDynamicWorkflowStatus } from 'state/dynamic/selectors';
import { getBookingType, getQuoteType } from 'state/quotes/selectors';
import type { ShareButtonColor } from 'state/quotes/utils';
import { getShareButtonColor } from 'state/quotes/utils';
import type { WorkFlowStatus } from 'state/selectors';
import { getFormQuoteId, getStaticWorkflowStatus } from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export interface StateProps {
  status: WorkFlowStatus;
  color?: ShareButtonColor;
  isForBooking?: boolean;
}

export type StatusProps = OwnProps & StateProps;

export const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const quoteId = getFormQuoteId(state, workspaceType, tabId);
  const quoteType = getQuoteType(state, quoteId);
  const bookingType = getBookingType(state, quoteId);
  const status =
    workspaceType === 'static' ? getStaticWorkflowStatus(state, tabId) : getDynamicWorkflowStatus(state, tabId);
  return {
    status,
    color: workspaceType === 'static' ? getShareButtonColor(status, quoteType) : undefined,
    isForBooking: isNonEmpty(bookingType),
  };
};

export const connectStatus = connect(mapStateToProps);
